import React from 'react';

import { useLocation } from 'react-router-dom';

type CommboxOnloadOmTriggerProps = {
  onClick: () => void;
  param?: string;
};

const CommboxOnloadOmTrigger = ({ onClick, param = 'create' }: CommboxOnloadOmTriggerProps) => {
  const urlSearchParams = new URLSearchParams(useLocation().search);

  React.useEffect(() => {
    const create = urlSearchParams.get(param);

    if (create === 'post') {
      onClick();
    }
  }, []);

  return null;
};

export { CommboxOnloadOmTrigger };
